<app-animated-background class="absolute top-0 h-vh w-dvw"></app-animated-background>
<div class="min-h-screen absolute top-0 w-full flex items-center justify-center p-4 z-[999]">
  <div class="w-full max-w-md login-card">
    <div class="header-section px-8 pt-8 pb-4">
      <div class="lock-icon">
        <mat-icon>lock</mat-icon>
      </div>
      <div class="text-center">
        <h1 class="welcome-title">Welcome Back</h1>
        <p class="welcome-subtitle">Sign in to your account</p>
      </div>
    </div>

    <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" class="form-section p-8">
      <div class="form-group">
        <mat-form-field appearance="outline" class="w-full enhanced-field">
          <mat-label>Email</mat-label>
          <input matInput formControlName="email" type="email" placeholder="Enter your email">
          <mat-icon matPrefix class="field-icon">email</mat-icon>
          <mat-error *ngIf="loginForm.get('email')?.hasError('required')">
            <mat-icon class="error-icon">error</mat-icon>
            Email is required
          </mat-error>
          <mat-error *ngIf="loginForm.get('email')?.hasError('email')">
            <mat-icon class="error-icon">error</mat-icon>
            Please enter a valid email
          </mat-error>
        </mat-form-field>
      </div>

      <div class="form-group">
        <mat-form-field appearance="outline" class="w-full enhanced-field">
          <mat-label>Password</mat-label>
          <input matInput [type]="hidePassword ? 'password' : 'text'" formControlName="password"
            placeholder="Enter your password">
          <mat-icon matPrefix class="field-icon">lock</mat-icon>
          <button mat-icon-button matSuffix (click)="hidePassword = !hidePassword" type="button" class="toggle-btn">
            <mat-icon>{{hidePassword ? 'visibility_off' : 'visibility'}}</mat-icon>
          </button>
          <mat-error *ngIf="loginForm.get('password')?.hasError('required')">
            <mat-icon class="error-icon">error</mat-icon>
            Password is required
          </mat-error>
        </mat-form-field>
      </div>

      <a routerLink="/forgot-password" class="text-end w-full opacity-60 hover:underline hover:opacity-100 mb-4">Forgot password</a>

      <button class="submit-button w-full" [disabled]="loading">
        <span class="button-content">
          @if (loading) {
          <mat-spinner diameter="20"></mat-spinner>
          <span>Signing In...</span>
          } @else {
          <mat-icon>login</mat-icon>
          <span>Sign In</span>
          }
        </span>
      </button>

      <div class="forgot-password flex items-center justify-center w-full gap-1 text-center">
        <p>Don't have an account?</p>
        <a routerLink="/register" class="forgot-link">Create One</a>
      </div>
    </form>
  </div>
</div>
